module.exports = __webpack_public_path__ + "static/media/share2.3a658e59.svg";